import React from 'react';
import {
  arrayOf,
  bool,
  node,
  oneOf,
  oneOfType,
  string
} from 'prop-types';
import classNames from 'classnames';
import '../sample.scss';

export const SampleImage = ({
  channel, children, className, mini, url
}) => {
  const imageContentClasses = classNames(className, 'sample__image-block', {
    'sample__image-block--mobile': channel === 'mobile' && !mini,
    'sample__image-block--mini': mini
  });
  return (
    <div className={imageContentClasses}>
      <img
        style={{ height: '100%' }}
        alt="sample"
        src={url}
      />
      {children}
    </div>
  );
};

SampleImage.displayName = 'SampleImage';

SampleImage.propTypes = {
  channel: oneOf(['desktop', 'mobile', 'tablet']),
  children: oneOfType([node, arrayOf(node)]),
  className: string,
  mini: bool,
  url: string.isRequired
};

SampleImage.defaultProps = {
  channel: 'desktop',
  children: null,
  className: null,
  mini: false
};
